<template>
  <div class="container">
    <VasionCheckbox
      id="merge-package-documents"
      name="mergePackageDocuments"
      :checked="mergePackageDocuments"
      @change="updateCheckbox('mergePackageDocuments')"
    >
      Merge Package Documents to Base Document
    </VasionCheckbox>
  </div>
</template>
<script>
export default {
  name: 'PackageTabDetails',
  data: function () {
    return {
      mergePackageDocuments: false,
    }
  },
  methods: {
    updateCheckbox(variable) {
      this[variable] = !this[variable]
    },
  },
}
</script>
<style lang="scss" scoped></style>
